import React, {Component} from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ReferralCompanyDetails from './components/Referral/ReferralCompanyDetails'
import { fetchReferral } from 'manager/redux/referral'
import { selectReferralRemovingNA } from 'manager/selectors/referral_selectors'

import {
  setTitle, setWhiteBanner
} from 'common/redux/root'

class ReferralCompanyDetailsContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      lender: this.props.location.pathname.includes("loan")
    }
  }

  componentWillMount() {
    const { dispatch } = this.props
    const { lender } = this.state
    dispatch(setWhiteBanner(true))
    dispatch(fetchReferral(this.props.params.hash, true)).then(
      response => {
        dispatch(setTitle((lender ? "Financing" : "Settlement Company") + " Details", response.referral.name))
      }
    )
  }

  render() {
    const { lender } = this.state
    const { referral } = this.props

    if (!referral) {
      return null
    }

    return lender ? (
      <ReferralCompanyDetails
        type="loan"
        digitalLender={!!referral.has_active_digital_loan_assignment}
        networkLabel="Lender"
        companyLabel="Lender"
        disclosureLabel="mortgage"
        company={referral.loan_broker_company}
        officerLabel="Loan"
        officer={referral.loan_officer_name}
        officerEmail={referral.loan_officer_email}
        officerPhone={referral.loan_officer_phone}
        officerPhoneFormatted={referral.loan_officer_phone_formatted}
        logoPath={referral.loan_broker_logo}
        profileName={referral.loan_broker_profile_name}
        url={referral.loan_broker_url}
        shortUrl={referral.loan_broker_short_url}
        description={referral.loan_broker_description}
        {...this.props}
      />
    ) : (
      <ReferralCompanyDetails
        type="settlement"
        networkLabel="Settlement Company"
        companyLabel="Settlement Company"
        disclosureLabel="settlement"
        company={referral.settlement_broker_company}
        officerLabel="Settlement"
        officer={referral.settlement_officer_name}
        officerEmail={referral.settlement_officer_email}
        officerPhone={referral.settlement_officer_phone}
        officerPhoneFormatted={referral.settlement_officer_phone_formatted}
        logoPath={referral.settlement_broker_logo}
        profileName={referral.settlement_broker_profile_name}
        url={referral.settlement_broker_url}
        shortUrl={referral.settlement_broker_short_url}
        description={referral.settlement_broker_description}
        {...this.props}
      />
    )
  }
}

const mapStateToProps = createStructuredSelector({
  referral: selectReferralRemovingNA
})

export default connect(mapStateToProps)(ReferralCompanyDetailsContainer)
